/* ════════════════════════════════════════════════
   FF Valmennusvalitsin V6 — Aikariippuvainen
   Schema-pohjaiset valmennuslähdöt + älykkäät säännöt
   ════════════════════════════════════════════════ */

(function() {
  'use strict';

  /* ─── State ─── */
  const answers = {};
  let currentStep = '1';
  let stepHistory = ['1'];

  /* Step flow: 1 → (1b if weightloss) → 2 → 3 → 4 → 5 → result */
  const STEP_FLOW = ['1', '1b', '2', '3', '4', '5'];
  const TOTAL_DISPLAY_STEPS = 5;

  function getDisplayStep() {
    const map = { '1': 1, '1b': 1, '2': 2, '3': 3, '4': 4, '5': 5 };
    return map[currentStep] || 1;
  }

  function getNextStep(current) {
    if (current === '1') return answers.goal === 'weightloss' ? '1b' : '2';
    if (current === '1b') return '2';
    if (current === '2') return '3';
    if (current === '3') return '4';
    if (current === '4') return '5';
    return 'result';
  }

  /* ─── Valmennuslähdöt (injektoidaan Liquidista) ─── */
  let LAUNCHES = [];
  try {
    var launchEl = document.getElementById('ffFinderLaunches');
    if (launchEl) LAUNCHES = JSON.parse(launchEl.textContent);
  } catch(e) { console.warn('Finder: launch data parse error', e); }

  /* ─── Kurssit / aina saatavilla olevat tuotteet ─── */
  const ALWAYS_AVAILABLE = {
    simppeli_course: {
      title: 'Simppeli',
      url: '/products/simppeli',
      img: 'https://www.fitfarm.fi/cdn/shop/files/SIMPPELI-HERO-TAMMI-NELIO.png?v=1765792001&width=400',
      price: 'alk. 59 €',
      type: 'course',
      category: 'weightloss',
      features: [
        'Yksinkertainen ja selkeä ohjelma',
        'Aloita heti, etene omaan tahtiin',
        'Valmiit ruokalistat ja treeniohjelmat',
        'Sopii kiireiselle arjelle'
      ],
      quote: '"Joskus yksinkertainen on parasta. Simppeli antaa kaiken mitä tarvitset."'
    },
    salitreeni: {
      title: 'Salitreeniohjelma',
      url: '/collections/treeniohjelmat',
      img: 'https://www.fitfarm.fi/cdn/shop/files/BASIC-NAISET-HERO_75bf840b-2a0e-4d0a-a4f1-39ec5f4a0fd7.png?v=1762774746&width=400',
      price: 'alk. 29 €',
      type: 'course',
      category: 'muscle',
      features: [
        'Ammattimaisesti suunniteltu saliohjelma',
        'Videodemot jokaiselle liikkeelle',
        'Eri tasot aloittelijasta edistyneeseen',
        'Lataa ja aloita heti'
      ],
      quote: '"Hyvä treeniohjelma on kuin kartta. Se näyttää suunnan, sinä kuljit matkan."'
    },
    reseptit: {
      title: 'Kevyeksi keittiössä',
      url: '/collections/reseptit',
      img: 'https://www.fitfarm.fi/cdn/shop/files/kevyeksi-24-1400x1400.jpg?v=1700174702&width=400',
      price: 'alk. 19 €',
      type: 'course',
      category: 'health',
      features: [
        'Satoja testattuja ja helppoja reseptejä',
        'Ravintolaskelmilla varustetut ateriasuunnitelmat',
        'Kauppalistat valmiina',
        'Sopii moneen eri ruokavalioon'
      ],
      quote: '"Hyvä ruoka on kaiken perusta."'
    }
  };

  /* ─── Aikapohjaiset apufunktiot ─── */
  function today() {
    return new Date();
  }

  function parseDate(str) {
    if (!str) return null;
    // Tukee muotoja: "2026-04-21", "21.4.2026", "2026-4-21"
    if (str.includes('-')) {
      var parts = str.split('-');
      return new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]));
    }
    if (str.includes('.')) {
      var p = str.split('.');
      return new Date(parseInt(p[2]), parseInt(p[1]) - 1, parseInt(p[0]));
    }
    return null;
  }

  function daysBetween(a, b) {
    return Math.round((b - a) / (1000 * 60 * 60 * 24));
  }

  function isStartWeek(startDate) {
    // Aloitusviikko = ma-su jolla aloituspäivä on
    var now = today();
    var start = parseDate(startDate);
    if (!start) return false;
    // Viikon alku (maanantai)
    var weekStart = new Date(start);
    var day = weekStart.getDay();
    var diff = day === 0 ? -6 : 1 - day; // ma = 1
    weekStart.setDate(weekStart.getDate() + diff);
    // Viikon loppu (sunnuntai)
    var weekEnd = new Date(weekStart);
    weekEnd.setDate(weekEnd.getDate() + 6);
    weekEnd.setHours(23, 59, 59);
    return now >= weekStart && now <= weekEnd;
  }

  function getAvailability(startDate) {
    var start = parseDate(startDate);
    if (!start) return { status: 'unknown', label: '' };
    var now = today();
    var daysUntil = daysBetween(now, start);

    if (isStartWeek(startDate)) {
      return { status: 'now', label: 'Aloita nyt!', urgency: 10 };
    }
    if (daysUntil < -7) {
      // Aloitusviikko on ohi
      return { status: 'past', label: 'Käynnissä — ei voi enää liittyä', urgency: 0 };
    }
    if (daysUntil >= -7 && daysUntil < 0) {
      // Juuri mennyt mutta viikon sisällä
      return { status: 'past', label: 'Aloitusviikko päättynyt', urgency: 0 };
    }
    if (daysUntil <= 7) {
      return { status: 'soon', label: 'Alkaa ensi viikolla!', urgency: 8 };
    }
    if (daysUntil <= 14) {
      return { status: 'soon', label: 'Alkaa 2 viikon päästä', urgency: 7 };
    }
    if (daysUntil <= 28) {
      var weeks = Math.ceil(daysUntil / 7);
      return { status: 'upcoming', label: 'Alkaa ' + weeks + ' viikon päästä', urgency: 5 };
    }
    if (daysUntil <= 90) {
      var monthNames = ['tammikuussa','helmikuussa','maaliskuussa','huhtikuussa','toukokuussa','kesäkuussa','heinäkuussa','elokuussa','syyskuussa','lokakuussa','marraskuussa','joulukuussa'];
      return { status: 'future', label: 'Tulossa ' + monthNames[start.getMonth()], urgency: 2 };
    }
    return { status: 'far', label: 'Tulossa myöhemmin', urgency: 1 };
  }

  function formatStartDate(startDate) {
    var d = parseDate(startDate);
    if (!d) return '';
    var day = d.getDate();
    var month = d.getMonth() + 1;
    return day + '.' + month + '.';
  }

  /* ─── Suosittelulogiikka V6 — aikariippuvainen ─── */
  function getRecommendation() {
    var goal = answers.goal;
    var activity = answers.activity;
    var support = answers.support;
    var age = answers.age;
    var targetKg = answers.targetKg || 8;

    // Jos itsenäinen → kurssit/saliohjelmat (aina saatavilla)
    if (support === 'self') {
      return getSelfRecommendation(goal);
    }

    // Valmentajan tuki → etsi saatavilla olevat valmennuslähdöt
    var available = getAvailableLaunches(goal, activity, age, targetKg);

    if (available.length === 0) {
      // Ei saatavilla olevia valmennuksia → suosittele kurssia + mainitse tuleva
      return getFallbackRecommendation(goal, activity, age, targetKg);
    }

    // Parhaat matchit järjestyksessä
    var primary = available[0];
    var alternatives = available.slice(1, 3);

    // Lisää kurssivaihtoehto jos tilaa
    if (alternatives.length < 2) {
      var courseAlt = getCourseAlternative(goal);
      if (courseAlt) alternatives.push(courseAlt);
    }

    return {
      primary: formatLaunchResult(primary),
      alternatives: alternatives.map(function(a) { return formatLaunchResult(a); }),
      interim: null
    };
  }

  function getAvailableLaunches(goal, activity, age, targetKg) {
    var now = today();
    var scored = [];

    LAUNCHES.forEach(function(launch) {
      var avail = getAvailability(launch.start_date);

      // Suodata pois menneet ja liian kaukaiset
      if (avail.status === 'past') return;
      if (avail.status === 'far') return; // yli 3kk päässä

      // Laske match-pisteet
      var score = 0;

      // Aikaperusteinen urgency (0-10)
      score += avail.urgency * 10;

      // Tavoite-match
      var tags = (launch.tags || '').toLowerCase();
      if (goal === 'weightloss' && (tags.includes('weightloss') || tags.includes('painonpudotus'))) score += 50;
      if (goal === 'tone' && (tags.includes('tone') || tags.includes('kiinteytys'))) score += 50;
      if (goal === 'muscle' && (tags.includes('muscle') || tags.includes('lihas'))) score += 50;
      if (goal === 'health' && (tags.includes('health') || tags.includes('hyvinvointi'))) score += 50;

      // Ikä-match
      if (age === '50+' && tags.includes('50+')) score += 40;
      if (age !== '50+' && tags.includes('50+')) score -= 20; // Ei suositella V50+ nuoremmille

      // Painotavoite-match (vain weightloss)
      if (goal === 'weightloss') {
        if (targetKg > 20 && tags.includes('xl')) score += 30;
        if (targetKg <= 10 && tags.includes('light')) score += 20;
        if (targetKg > 10 && targetKg <= 20 && tags.includes('medium')) score += 20;
      }

      // Aktiivisuus-match
      if (activity === 'sedentary' && tags.includes('beginner')) score += 15;
      if (activity === 'active' && tags.includes('sport')) score += 15;

      scored.push({
        launch: launch,
        availability: avail,
        score: score
      });
    });

    // Järjestä pisteiden mukaan (korkein ensin)
    scored.sort(function(a, b) { return b.score - a.score; });

    return scored;
  }

  function formatLaunchResult(scoredLaunch) {
    var l = scoredLaunch.launch;
    var avail = scoredLaunch.availability;
    return {
      title: l.title,
      url: l.url || '#',
      img: l.image || '',
      price: l.price || '',
      type: 'coached',
      features: l.features ? l.features.split('|') : [],
      quote: l.quote || '',
      availability: avail,
      startDate: l.start_date,
      duration: l.duration || ''
    };
  }

  function getSelfRecommendation(goal) {
    var primary, alts;
    if (goal === 'muscle') {
      primary = ALWAYS_AVAILABLE.salitreeni;
      alts = [ALWAYS_AVAILABLE.simppeli_course, ALWAYS_AVAILABLE.reseptit];
    } else if (goal === 'weightloss' || goal === 'tone') {
      primary = ALWAYS_AVAILABLE.simppeli_course;
      alts = [ALWAYS_AVAILABLE.reseptit, ALWAYS_AVAILABLE.salitreeni];
    } else {
      primary = ALWAYS_AVAILABLE.reseptit;
      alts = [ALWAYS_AVAILABLE.simppeli_course, ALWAYS_AVAILABLE.salitreeni];
    }
    return {
      primary: Object.assign({}, primary, {
        availability: { status: 'always', label: 'Aloita heti!', urgency: 10 }
      }),
      alternatives: alts.map(function(a) {
        return Object.assign({}, a, {
          availability: { status: 'always', label: 'Aloita heti!', urgency: 10 }
        });
      }),
      interim: null
    };
  }

  function getCourseAlternative(goal) {
    if (goal === 'muscle') return Object.assign({}, ALWAYS_AVAILABLE.salitreeni, {
      availability: { status: 'always', label: 'Aloita heti!', urgency: 10 }
    });
    if (goal === 'weightloss' || goal === 'tone') return Object.assign({}, ALWAYS_AVAILABLE.simppeli_course, {
      availability: { status: 'always', label: 'Aloita heti!', urgency: 10 }
    });
    return Object.assign({}, ALWAYS_AVAILABLE.reseptit, {
      availability: { status: 'always', label: 'Aloita heti!', urgency: 10 }
    });
  }

  function getFallbackRecommendation(goal, activity, age, targetKg) {
    // Ei saatavilla olevia valmennuksia → suosittele kurssia + etsi seuraava tuleva
    var courseRec = getSelfRecommendation(goal);

    // Etsi seuraava tuleva valmennus (myös kaukaiset)
    var futureLaunches = [];
    LAUNCHES.forEach(function(launch) {
      var avail = getAvailability(launch.start_date);
      if (avail.status === 'far' || avail.status === 'future') {
        var tags = (launch.tags || '').toLowerCase();
        var goalMatch = false;
        if (goal === 'weightloss' && tags.includes('weightloss')) goalMatch = true;
        if (goal === 'tone' && tags.includes('tone')) goalMatch = true;
        if (goal === 'muscle' && tags.includes('muscle')) goalMatch = true;
        if (goal === 'health' && tags.includes('health')) goalMatch = true;
        if (goalMatch) {
          futureLaunches.push({ launch: launch, availability: avail });
        }
      }
    });

    // Järjestä aloituspäivän mukaan (lähin ensin)
    futureLaunches.sort(function(a, b) {
      var da = parseDate(a.launch.start_date);
      var db = parseDate(b.launch.start_date);
      return da - db;
    });

    var interim = null;
    if (futureLaunches.length > 0) {
      var fl = futureLaunches[0];
      interim = {
        title: fl.launch.title,
        startDate: fl.launch.start_date,
        url: fl.launch.url || '#',
        availability: fl.availability
      };
    }

    courseRec.interim = interim;
    return courseRec;
  }

  /* ─── Slider reactions ─── */
  function getSliderReaction(kg) {
    if (kg <= 3) return 'Pienikin muutos tuntuu! Tähän riittää lyhyt ja tehokas ohjelma.';
    if (kg <= 6) return 'Hyvä tavoite! Tähän pääsee muutamassa viikossa oikealla ohjelmalla.';
    if (kg <= 10) return 'Realistinen ja saavutettava! Löydämme sinulle sopivan ohjelman.';
    if (kg <= 15) return 'Kunnianhimoista! Valmentajan tuella tämä onnistuu varmasti.';
    if (kg <= 20) return 'Iso muutos! Tähän tarvitaan hyvä suunnitelma ja valmentajan tuki.';
    if (kg <= 25) return 'Vau, olet tosissasi! Tähän löytyy perusteellinen ohjelma.';
    return 'Elämää muuttava tavoite! Olet oikeassa paikassa. Tehdään tämä yhdessä!';
  }

  function getWhyText() {
    var goal = answers.goal;
    var support = answers.support;
    var goalTexts = {
      weightloss: 'pudottaa painoa',
      tone: 'kiinteytyä ja saada energiaa',
      muscle: 'kasvattaa lihasta',
      health: 'voida paremmin kokonaisvaltaisesti'
    };
    var supportText = support === 'coached' ? 'valmentajan tuella' : 'omaan tahtiin';
    return 'Koska haluat ' + (goalTexts[goal] || 'tehdä muutoksen') + ' — ' + supportText + '.';
  }

  /* ─── Mystery card rewards ─── */
  var mysteryRewards = [
    { title: 'Sisäpiirietu!', text: 'Saat 10 % alennuksen ensimmäisestä valmennuksestasi. Koodi tulee sähköpostiisi!', icon: 'fa-regular fa-tag' },
    { title: 'Ilmainen reseptipaketti!', text: 'Saat ilmaisen Kevyeksi Keittiössä -reseptipaketin valmennuksen lisäksi!', icon: 'fa-regular fa-utensils' },
    { title: 'VIP-pääsy!', text: 'Saat kutsun Fitfarmin suljettuun Sisäpiiri-ryhmään ja valmentajien live-sessioihin!', icon: 'fa-regular fa-star' },
    { title: 'Tsemppibonus!', text: 'Saat henkilökohtaisen tsemppiviestin valmentajalta valmennuksen alkaessa!', icon: 'fa-regular fa-envelope-heart' }
  ];

  /* ─── UI-funktiot ─── */
  function updateProgress() {
    var displayStep = getDisplayStep();
    var pct = (displayStep / TOTAL_DISPLAY_STEPS) * 100;
    var bar = document.getElementById('ffFinderProgress');
    var count = document.getElementById('ffFinderStepCount');
    if (bar) bar.style.width = pct + '%';
    if (count) count.textContent = displayStep + ' / ' + TOTAL_DISPLAY_STEPS;
  }

  function showStep(stepId) {
    currentStep = stepId;
    if (stepHistory[stepHistory.length - 1] !== stepId) {
      stepHistory.push(stepId);
    }
    updateProgress();

    document.querySelectorAll('.ff-finder__step').forEach(function(s) {
      s.classList.remove('is-active');
      s.style.display = 'none';
    });

    var target = document.querySelector('.ff-finder__step[data-step="' + stepId + '"]');
    if (target) {
      target.style.display = 'block';
      requestAnimationFrame(function() { target.classList.add('is-active'); });
    }

    var back = document.getElementById('ffFinderBack');
    if (back) back.style.display = stepId !== '1' ? 'flex' : 'none';

    var result = document.getElementById('ffFinderResult');
    if (result) result.style.display = 'none';

    var progress = document.querySelector('.ff-finder__progress');
    var stepCount = document.getElementById('ffFinderStepCount');
    if (progress) progress.style.display = '';
    if (stepCount) stepCount.style.display = '';

    var finder = document.getElementById('ff-finder');
    if (finder) finder.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function showResult() {
    document.querySelectorAll('.ff-finder__step').forEach(function(s) {
      s.classList.remove('is-active');
      s.style.display = 'none';
    });
    document.getElementById('ffFinderBack').style.display = 'none';
    document.querySelector('.ff-finder__progress').style.display = 'none';
    document.getElementById('ffFinderStepCount').style.display = 'none';

    var result = document.getElementById('ffFinderResult');
    var loading = document.getElementById('ffFinderLoading');
    var content = document.getElementById('ffFinderResultContent');

    result.style.display = 'block';
    loading.style.display = 'flex';
    content.style.display = 'none';

    result.scrollIntoView({ behavior: 'smooth', block: 'start' });

    var loadingSteps = document.querySelectorAll('.ff-finder__loading-step');
    loadingSteps.forEach(function(step) {
      step.classList.remove('is-visible');
      var delay = parseInt(step.dataset.delay) || 0;
      setTimeout(function() { step.classList.add('is-visible'); }, delay);
    });

    setTimeout(function() {
      loading.style.display = 'none';
      populateResult();
      content.style.display = 'block';
      requestAnimationFrame(function() { content.classList.add('is-visible'); });
    }, 2200);
  }

  function populateResult() {
    var rec = getRecommendation();
    var product = rec.primary;

    // Title & availability badge
    document.getElementById('ffResultTitle').textContent = product.title;
    document.getElementById('ffResultWhy').textContent = getWhyText();

    // Availability badge
    var badgeEl = document.querySelector('.ff-finder__result-badge');
    if (badgeEl && product.availability) {
      var avail = product.availability;
      if (avail.status === 'now') {
        badgeEl.innerHTML = '<i class="fa-regular fa-circle-check"></i> ' + avail.label;
        badgeEl.className = 'ff-finder__result-badge ff-finder__result-badge--now';
      } else if (avail.status === 'soon' || avail.status === 'upcoming') {
        badgeEl.innerHTML = '<i class="fa-regular fa-calendar-clock"></i> ' + avail.label;
        badgeEl.className = 'ff-finder__result-badge ff-finder__result-badge--soon';
      } else if (avail.status === 'always') {
        badgeEl.innerHTML = '<i class="fa-regular fa-bolt"></i> Aloita heti!';
        badgeEl.className = 'ff-finder__result-badge ff-finder__result-badge--now';
      } else {
        badgeEl.innerHTML = '<i class="fa-regular fa-circle-check"></i> Sinulle suosittelemme';
        badgeEl.className = 'ff-finder__result-badge';
      }
    }

    // Image
    var img = document.getElementById('ffResultImg');
    if (product.img) {
      img.src = product.img;
      img.alt = product.title;
      img.parentElement.style.display = '';
    } else {
      img.parentElement.style.display = 'none';
    }

    // Features
    var featuresList = document.getElementById('ffResultFeatures');
    featuresList.innerHTML = product.features.map(function(f) {
      return '<li><i class="fa-regular fa-circle-check"></i> ' + f.trim() + '</li>';
    }).join('');

    // Duration + start date
    var durationEl = document.getElementById('ffResultDuration');
    if (durationEl) {
      var durationParts = [];
      if (product.duration) durationParts.push(product.duration);
      if (product.startDate && product.availability && product.availability.status !== 'always') {
        durationParts.push('Alkaa ' + formatStartDate(product.startDate));
      }
      durationEl.textContent = durationParts.join(' — ');
      durationEl.style.display = durationParts.length > 0 ? '' : 'none';
    }

    // Price
    document.getElementById('ffResultPrice').textContent = product.price;

    // CTA
    var cta = document.getElementById('ffResultCTA');
    cta.href = product.url;
    if (product.availability && product.availability.status === 'now') {
      cta.innerHTML = 'Aloita nyt <i class="fa-regular fa-arrow-right"></i>';
    } else if (product.availability && (product.availability.status === 'soon' || product.availability.status === 'upcoming')) {
      cta.innerHTML = 'Varaa paikkasi <i class="fa-regular fa-arrow-right"></i>';
    } else {
      cta.innerHTML = 'Tutustu ja aloita <i class="fa-regular fa-arrow-right"></i>';
    }

    // Quote
    var quoteEl = document.getElementById('ffResultQuote');
    if (product.quote) {
      quoteEl.textContent = product.quote;
      quoteEl.closest('.ff-finder__result-quote').style.display = '';
    }

    // Interim recommendation ("in the meanwhile")
    var interimEl = document.getElementById('ffResultInterim');
    if (interimEl && rec.interim) {
      interimEl.style.display = 'block';
      var interimTitle = interimEl.querySelector('.ff-finder__interim-title');
      var interimText = interimEl.querySelector('.ff-finder__interim-text');
      var interimLink = interimEl.querySelector('.ff-finder__interim-link');
      if (interimTitle) interimTitle.textContent = rec.interim.title;
      if (interimText) interimText.textContent = 'Seuraava ' + rec.interim.title + ' alkaa ' + formatStartDate(rec.interim.startDate) + '. Sillä välin voit aloittaa tällä!';
      if (interimLink) interimLink.href = rec.interim.url;
    } else if (interimEl) {
      interimEl.style.display = 'none';
    }

    // Alternatives
    var alsoGrid = document.getElementById('ffResultAlsoGrid');
    alsoGrid.innerHTML = rec.alternatives.map(function(p) {
      var availLabel = '';
      if (p.availability) {
        if (p.availability.status === 'now' || p.availability.status === 'always') {
          availLabel = '<span class="ff-finder__also-avail ff-finder__also-avail--now">' + p.availability.label + '</span>';
        } else if (p.availability.status === 'soon' || p.availability.status === 'upcoming') {
          availLabel = '<span class="ff-finder__also-avail ff-finder__also-avail--soon">' + p.availability.label + '</span>';
        }
      }
      return '<a href="' + p.url + '" class="ff-finder__also-card">' +
        (p.img ? '<div class="ff-finder__also-img"><img src="' + p.img + '" alt="' + p.title + '"></div>' : '') +
        '<div class="ff-finder__also-info">' +
          '<strong>' + p.title + '</strong>' +
          availLabel +
          '<span>' + p.price + '</span>' +
        '</div>' +
        '</a>';
    }).join('');

    // Mystery card (only if email was provided)
    var mysteryEl = document.getElementById('ffMystery');
    if (answers.email) {
      mysteryEl.style.display = 'block';
      var reward = mysteryRewards[Math.floor(Math.random() * mysteryRewards.length)];
      document.getElementById('ffMysteryTitle').textContent = reward.title;
      document.getElementById('ffMysteryText').textContent = reward.text;
      var mysteryIcon = mysteryEl.querySelector('.ff-finder__mystery-icon');
      if (mysteryIcon) mysteryIcon.innerHTML = '<i class="' + reward.icon + '"></i>';
    } else {
      mysteryEl.style.display = 'none';
    }
  }

  /* ─── Event Listeners ─── */
  function init() {
    var finder = document.getElementById('ff-finder');
    if (!finder) return;

    // Choice buttons (auto-advance)
    finder.addEventListener('click', function(e) {
      var choice = e.target.closest('.ff-finder__choice');
      if (!choice) return;
      var key = choice.dataset.key;
      var value = choice.dataset.value;
      if (!key || !value) return;

      answers[key] = value;

      var step = choice.closest('.ff-finder__step');
      step.querySelectorAll('.ff-finder__choice').forEach(function(c) {
        c.classList.remove('is-selected');
      });
      choice.classList.add('is-selected');

      setTimeout(function() {
        var next = getNextStep(currentStep);
        if (next === 'result') {
          showResult();
        } else {
          showStep(next);
        }
      }, 350);
    });

    // Slider
    var slider = document.getElementById('ffWeightSlider');
    var sliderValue = document.getElementById('ffSliderValue');
    var sliderReaction = document.getElementById('ffSliderReaction');
    var sliderNext = document.getElementById('ffSliderNext');

    if (slider) {
      slider.addEventListener('input', function() {
        var kg = parseInt(this.value);
        answers.targetKg = kg;
        if (sliderValue) sliderValue.textContent = kg + ' kg';
        if (sliderReaction) sliderReaction.textContent = getSliderReaction(kg);
      });
    }
    if (sliderNext) {
      sliderNext.addEventListener('click', function() {
        answers.targetKg = parseInt(slider.value);
        showStep('2');
      });
    }

    // Email submit
    var submitBtn = document.getElementById('ffFinderSubmit');
    var emailInput = document.getElementById('ffFinderEmail');

    if (submitBtn) {
      submitBtn.addEventListener('click', function() {
        var email = emailInput ? emailInput.value.trim() : '';
        if (!email || !email.includes('@')) {
          emailInput.classList.add('is-error');
          emailInput.focus();
          return;
        }
        emailInput.classList.remove('is-error');
        answers.email = email;
        showResult();
      });
    }
    if (emailInput) {
      emailInput.addEventListener('keydown', function(e) {
        if (e.key === 'Enter') { e.preventDefault(); submitBtn.click(); }
      });
      emailInput.addEventListener('input', function() { this.classList.remove('is-error'); });
    }

    // Skip email
    var skipBtn = document.getElementById('ffFinderSkip');
    if (skipBtn) {
      skipBtn.addEventListener('click', function() {
        answers.email = null;
        showResult();
      });
    }

    // Back button
    var backBtn = document.getElementById('ffFinderBack');
    if (backBtn) {
      backBtn.addEventListener('click', function() {
        if (stepHistory.length > 1) {
          stepHistory.pop();
          var prev = stepHistory[stepHistory.length - 1];
          showStep(prev);
          if (stepHistory.length > 1 && stepHistory[stepHistory.length - 1] === stepHistory[stepHistory.length - 2]) {
            stepHistory.pop();
          }
        }
      });
    }

    // Mystery card flip
    var mysteryCard = document.getElementById('ffMysteryCard');
    if (mysteryCard) {
      mysteryCard.addEventListener('click', function() { this.classList.toggle('is-flipped'); });
    }

    // Restart
    var restartBtn = document.getElementById('ffFinderRestart');
    if (restartBtn) {
      restartBtn.addEventListener('click', function() {
        Object.keys(answers).forEach(function(k) { delete answers[k]; });
        finder.querySelectorAll('.ff-finder__choice').forEach(function(c) { c.classList.remove('is-selected'); });
        if (emailInput) emailInput.value = '';
        if (slider) {
          slider.value = 8;
          if (sliderValue) sliderValue.textContent = '8 kg';
          if (sliderReaction) sliderReaction.textContent = getSliderReaction(8);
        }
        document.getElementById('ffFinderResultContent').classList.remove('is-visible');
        if (mysteryCard) mysteryCard.classList.remove('is-flipped');
        stepHistory = ['1'];
        showStep('1');
      });
    }

    // Initialize
    showStep('1');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
